/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import MappingTable from './MappingTable';
import MappingSheets from './MappingSheets';
import { parseMoney } from '../utils';
import ProgressBarModal from '../progress_bar/ProgressBarModal';
import FduSelect from '../financial_data_uploads/FduSelect';
import MappingDragger from './MappingDragger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { useTour } from '@reactour/tour';
window.selections = {};

const inBalanceRange = (assets, liabilities) => {
  let r1 = assets - 1.44;
  let r2 = assets + 1.44;
  return r1 <= liabilities && liabilities <= r2
}

const Mapper = (props) => {
  const tableRef = useRef(null);
  const { isOpen, currentStep, setIsOpen, setCurrentStep } = useTour();
  const [isFetching, setIsFetching] = useState(true);
  const [lastFdr, setLastFdr] = useState(1);
  const [fdrs, setFdrs] = useState([]);
  const [viewableFdrs, setViewableFdrs] = useState([]);
  const [rowHeights, setRowHeights] = useState({});
  const [rowTops, setRowTops] = useState({});
  const [lastViewedRow, setLastViewedRow] = useState(0);
  const [sortType, setSortType] = useState('account_number');
  const [tableSort, setTableSort] = useState({
    account_number: 'asc',
    account_type: '',
    extracted_account: '',
    historic_matched: '',
    xlsx_matched: '',
    n_bayes_matched: '',
    ai_match: '',
    final_account: '',
  })
  const [tableSortYears, setTableSortYears] = useState({
    year_2010: '',
    year_2011: '',
    year_2012: '',
    year_2013: '',
    year_2014: '',
    year_2015: '',
    year_2016: '',
    year_2017: '',
    year_2018: '',
    year_2019: '',
    year_2020: '',
    year_2021: '',
    year_2022: '',
    year_2023: '',
    year_2024: '',
    year_2025: '',
    year_2026: '',
    year_2027: '',
    year_2028: '',
    year_2029: '',
    year_2030: ''
  })
  const [jobID, setJobID] = useState('')
  const [values, setValues] = useState(props.values);
  const [hideHistorics, setHideHistorics] = useState(true);
  // const [hideExactMatches, setHideExactMatches] = useState(true);
  const [reportsProgressBar, setReportsProgressBar] = useState(false);
  const [practiceCalcsProgressBar, setPracticeCalcsProgressBar] = useState(false);
  const [sameAccountsProgressBar, setSameAccountsProgressBar] = useState(false);
  const [tab, setTab] = useState('mapper')
  const [update, setUpdate] = useState(false);
  const [whoReviewed, setWhoReviewed] = useState(props.fdu_who_reviewed)
  const lastYearValues = values[props.years[props.years.length - 1]];
  const balanced = lastYearValues ? inBalanceRange(lastYearValues.total_assets, lastYearValues.total_liabilities_and_equity) : false;
  const [accountsExpanded, setAccountsExpanded] = useState({})
  const [rowsInExpand, setRowsInExpand] = useState({});
  const [displayFileInfo, setDisplayFileInfo] = useState(false);

  useEffect(() => {
    props.tourData.tracker_id && !props.tourData.tour_taken ? setIsOpen(true) : null
  }, []);


  useEffect(() => {
    async function handleFetch() {
      if (isFetching) {
        await fetchRows(lastFdr);
      };
    };
    handleFetch();
  }, [isFetching, lastFdr]);

  const TourBtn = () => {
    const questionCircle = <FontAwesomeIcon icon={faQuestionCircle} />
    return (
      <button className='hide-on-print' onClick={() => setIsOpen(true)}>{questionCircle}</button>
    )
  }

  const measureTextHeight = (text, width = 150) => {
    const div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.visibility = 'hidden';
    div.style.whiteSpace = 'normal';
    div.style.wordBreak = 'break-word';
    div.style.maxWidth = `${width}px`;

    // Match your .virtual-cell styles:
    div.style.fontSize = '14px';
    div.style.fontFamily = 'Lato, Arial, sans-serif';
    div.style.lineHeight = '1.428571429';
    div.style.padding = '2px';
    div.style.border = '1px solid #ddd';
    div.style.boxSizing = 'border-box';
    div.style.minHeight = '66px';
    div.style.width = `${width}px`;
    div.style.pointerEvents = 'none';
    div.textContent = text;


    document.body.appendChild(div);
    const height = div.getBoundingClientRect().height;
    document.body.removeChild(div);
    return height;
  }

  async function fetchRows(lastFdr) {
    const response = await fetch(`/mapping_approvals/rows/${props.fdu_id}`, {
      headers: {
        'X-CSRF-Token': window.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        last_fdr: lastFdr
      })
    });
    const { last_fdr, fdrs } = await response.json();
    setIsFetching(false);
    setLastFdr(last_fdr);
    fdrs.forEach((r, i) => {
      r['rowHeight'] = getRowHeight(r.extracted_account);
    })
    handleRowDisplay(null, fdrs)
    setFdrs(prevFdrs => prevFdrs.concat(fdrs));
  };


  const updateRowInState = (ids, newValue) => {
    setViewableFdrs((prevState) => {
      const idSet = new Set(ids); // faster lookup for multiple ids
      return prevState.map(row =>
        idSet.has(row.id)
          ? { ...row, final_account: newValue }
          : row
      );
    });

    setFdrs((prevState) => {
      const idSet = new Set(ids); // faster lookup for multiple ids
      return prevState.map(row =>
        idSet.has(row.id)
          ? { ...row, final_account: newValue }
          : row
      );
    });
  };

  const handleNewNbayesValue = (id, value) => {
    setViewableFdrs((prevState) => {
      const index = prevState.findIndex((row) => row.id === id);
      if (index === -1) return prevState;
      const updatedRow = { ...prevState[index], n_bayes_matched: value };
      const newRows = [...prevState];
      newRows[index] = updatedRow;
      return newRows;
    })

    setFdrs((prevState) => {
      const index = prevState.findIndex((row) => row.id === id);
      if (index === -1) return prevState;
      const updatedRow = { ...prevState[index], n_bayes_matched: value };
      const newRows = [...prevState];
      newRows[index] = updatedRow;
      return newRows;
    })
  }

  async function updateRows(fdr_ids, account, drag = false, n_bayes_match = false, prevAccount = null) {
    const response = await fetch(`/mapping_approvals/row/${window.data.fdu_id}`, {
      headers: {
        'X-CSRF-Token': window.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({
        fdr_ids, account, n_bayes_match
      })
    });
    const { values } = await response.json();
    setValues(values);
    drag ? setUpdate(true) : setUpdate(false)

    updateRowInState(fdr_ids, account)

    if (prevAccount) {
      setRowsInExpand(prevState => {
        const prevRows = prevState[prevAccount] || [];
        let row = prevRows.find(r => r.id === fdr_ids[0]);
        if (!row) return prevState;
        row.final_account = account;
        let newRows = prevRows.filter(r => r.id !== fdr_ids[0]);
        return {
          ...prevState,
          [prevAccount]: newRows,
          [account]: [row, ...(prevState[account] || [])]
        }
      })
    }
  };

  async function recalculate() {
    const response = await fetch(`/mapping_approvals/recalculate/${window.data.fdu_id}`, {
      headers: {
        'X-CSRF-Token': window.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST'
    });
    const res = await response.json();
    if (res.ok) {
      window.location.reload();
    } else {
      console.log(res);
    }
  }

  async function remap() {
    const response = await fetch(`/mapping_approvals/remap/${window.data.fdu_id}`, {
      headers: {
        'X-CSRF-Token': window.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST'
    });
    const res = await response.json();
    if (res.ok) {
      window.location.reload();
    } else {
      console.log(res);
    }
  }

  const getRelatedAccounts = async (accountName) => {
    if (!accountsExpanded[accountName]) {
      const res = await fetch(`/mapping_approvals/grab_related_rows`, {
        headers: {
          'X-CSRF-Token': window.token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ id: props.fdu_id, final_account: accountName })
      });
      const resJson = await res.json();

      if (res.ok) {
        setAccountsExpanded((prevState) => {
          return {
            ...prevState,
            [accountName]: true
          }
        })
        setRowsInExpand((prevState) => {
          return {
            ...prevState,
            [accountName]: resJson['rows']
          }
        })
      } else {
        console.log(res);
      }
    } else {
      setAccountsExpanded((prevState) => {
        return {
          ...prevState,
          [accountName]: false
        }
      })
    }
  }

  const handleReview = async (e) => {
    e.preventDefault()
    const res = await fetch(`/mapping_approvals/who_reviewed/${window.data.fdu_id}`, {
      headers: {
        'X-CSRF-Token': window.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
    });
    const resJson = await res.json();

    if (res.ok) {
      setWhoReviewed(resJson.who_reviewed)
    } else {
      console.log(res);
    }
  }

  const handleRowSort = (type) => {
    let direction = '';
    setIsFetching(true);
    if (type.includes('year')) {
      setSortType(type)
      direction = tableSortYears[type];
      direction = direction === 'asc' ? 'desc' : direction === 'desc' ? '' : 'asc';
      setTableSortYears((prevState) => {
        const updated = Object.fromEntries(Object.keys(prevState).map(k => [k, '']));
        updated[type] = direction;
        return updated;
      });
    } else {
      setSortType(type)
      direction = tableSort[type];
      direction = direction === 'asc' ? 'desc' : direction === 'desc' ? '' : 'asc';
      setTableSort((prevState) => {
        const updated = Object.fromEntries(Object.keys(prevState).map(k => [k, '']));
        updated[type] = direction;
        return updated;
      });
    }

    // Don't sort if direction is empty (toggle-off)
    if (direction === '') return;

    let sortedRows = []
    setViewableFdrs(prevFdrs => {
      const sorted = [...prevFdrs].sort((a, b) => {
        let valA = a[type];
        let valB = b[type];
        const isBlankA = valA === null || valA === undefined || valA === '';
        const isBlankB = valB === null || valB === undefined || valB === '';

        // Send blanks to end if ascending
        if (direction === 'asc') {
          if (isBlankA && !isBlankB) return 1;
          if (!isBlankA && isBlankB) return -1;
        }

        // Send blanks to start if descending (optional)
        if (direction === 'desc') {
          if (isBlankA && !isBlankB) return -1;
          if (!isBlankA && isBlankB) return 1;
        }

        // Normalize non-blank values
        valA = isBlankA ? '' : valA;
        valB = isBlankB ? '' : valB;

        // If both are numbers (like year values), compare numerically
        if (!isNaN(valA) && !isNaN(valB)) {
          return direction === 'asc' ? valA - valB : valB - valA;
        }

        // Fallback to string comparison
        return direction === 'asc'
          ? valA.toString().localeCompare(valB.toString())
          : valB.toString().localeCompare(valA.toString());
      });
      sortedRows = sorted
      return sorted;
    });

    let totalTop = 0;
    const newRowHeights = {}
    const newRowTops = {}
    setRowHeights(prevState => {
      sortedRows.forEach((r, i) => {
        newRowHeights[i] = r['rowHeight'] ? r['rowHeight'] : getRowHeight(r.extracted_account);
      })
      return newRowHeights
    })

    setRowTops(prevState => {
      Object.keys(newRowHeights).forEach((i) => {
        newRowTops[i] = totalTop
        totalTop += newRowHeights[i]
      })
      return newRowTops
    })
    setIsFetching(false);
  };

  const mappingDragger = new MappingDragger({
    onMouseUp: ({ fdrs, value }) => {
      fdrs.forEach(id => window.selections[id] = value);
      updateRows(fdrs, value, true, false);
    }
  });

  const handleGenerateReports = async (e) => {
    e.preventDefault()
    document.querySelector('.mapper-sticky').style.zIndex = 0;
    setReportsProgressBar(true);

    const response = await fetch(`/mapping_approvals`, {
      headers: {
        'X-CSRF-Token': window.token,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ id: props.fdu_id })
    });
    const res = await response.json();

    if (res.ok) {
      setJobID(res['job_id'])
    } else {
      console.log(res);
    }
  }

  const getRowHeight = (extracted_account) => {
    // ~21 characters per line for 14px for a div width of 150px
    // 18px height lines
    const measuredHeight = measureTextHeight(extracted_account, 150);
    const finalHeight = measuredHeight > 66 ? measuredHeight : 66;
    return finalHeight;
  }

  const handleRowDisplay = (type = null, rows = []) => {
    let newHideHistorics = hideHistorics;

    if (type === 'historic') {
      newHideHistorics = !hideHistorics;
      setHideHistorics(prev => !prev);
    }
    let fileRows = rows.length > 0 ? rows : fdrs;
    let displayRows = []
    if (newHideHistorics) {
      fileRows.forEach(r => {
        if (!r.historic_matched) {
          displayRows.push(r)
        }
      })
    } else {
      displayRows = fileRows
    }

    let sortedRows = []
    let direction = '';
    if (sortType.includes('year')) {
      direction = tableSortYears[sortType];
    } else {
      direction = tableSort[sortType];
    }
    setViewableFdrs((prevState) => {
      if (direction === '') {
        sortedRows = displayRows;
        return displayRows;
      } else {
        const sorted = displayRows.sort((a, b) => {
          let valA = a[sortType];
          let valB = b[sortType];
          const isBlankA = valA === null || valA === undefined || valA === '';
          const isBlankB = valB === null || valB === undefined || valB === '';

          // Send blanks to end if ascending
          if (direction === 'asc') {
            if (isBlankA && !isBlankB) return 1;
            if (!isBlankA && isBlankB) return -1;
          }

          // Send blanks to start if descending (optional)
          if (direction === 'desc') {
            if (isBlankA && !isBlankB) return -1;
            if (!isBlankA && isBlankB) return 1;
          }

          // Normalize non-blank values
          valA = isBlankA ? '' : valA;
          valB = isBlankB ? '' : valB;

          // If both are numbers (like year values), compare numerically
          if (!isNaN(valA) && !isNaN(valB)) {
            return direction === 'asc' ? valA - valB : valB - valA;
          }

          // Fallback to string comparison
          return direction === 'asc'
            ? valA.toString().localeCompare(valB.toString())
            : valB.toString().localeCompare(valA.toString());
        });
        sortedRows = sorted
        return sorted;
      }
    })

    let totalTop = 0;
    const newRowHeights = {}
    const newRowTops = {}
    setRowHeights(prevState => {
      sortedRows.forEach((r, i) => {
        newRowHeights[i] = r['rowHeight'] ? r['rowHeight'] : getRowHeight(r.extracted_account);
      })
      return newRowHeights
    })

    setRowTops(prevState => {
      Object.keys(newRowHeights).forEach((i) => {
        newRowTops[i] = totalTop
        totalTop += newRowHeights[i]
      })
      return newRowTops
    })
  }

  const renderFileInfo = () => {
    if (props.user_type === 'Admin' && props.fdu_confidence_percent && displayFileInfo) {
      const threeStandard = (props.fdu_match_methods?.['exact_firm_naics_account_number_standard'] || 0) + (props.fdu_match_methods?.['exact_firm_naics_account_number'] || 0)
      const twoStandard = (props.fdu_match_methods?.['exact_firm_naics_standard'] || 0) + (props.fdu_match_methods?.['exact_firm_naics'] || 0)
      const allFirm = (props.fdu_match_methods?.['exact_firm_standard'] || 0) + (props.fdu_match_methods?.['exact_firm'] || 0)
      const allApp = (props.fdu_match_methods?.['exact_all_standard'] || 0) + (props.fdu_match_methods?.['exact_all'] || 0)

      return (
        <div>
          <button onClick={() => setDisplayFileInfo(false)}>{`Confidence: ${props.fdu_confidence_percent.toFixed(2)}% - Hide Match Details`}</button>
          <div>{`Historic: ${props.fdu_match_methods?.['historic']}`}</div>
          <div>{`AI: ${props.fdu_match_methods?.['ai']}`}</div>
          <div>{`Exact COA: ${props.fdu_match_methods?.['exact_coa_name']}`}</div>
          <div>{`Exact: ${props.fdu_match_methods?.['exact']}`}</div>
          <div>{`Exact Firm, NAICS, & Acct. Number: ${threeStandard}`}</div>
          <div>{`Exact Firm & NAICS: ${twoStandard}`}</div>
          <div>{`Exact Firm, NAICS, & Acct. Type: ${props.fdu_match_methods?.['exact_firm_naics_account_type'] }`}</div>
          <div>{`Exact Firm & Acct. Type: ${props.fdu_match_methods?.['exact_firm_account_type'] }`}</div>
          <div>{`Exact Firm: ${allFirm}`}</div>
          <div>{`Exact All App w/Acct. Type: ${props.fdu_match_methods?.['exact_all_account_type']}`}</div>
          <div>{`Exact All App: ${allApp}`}</div>
          <div>{`Exact Words w/Acct. Type: ${props.fdu_match_methods?.['exact_by_words_account_type']}`}</div>
          <div>{`Exact Words w/Standard Acct. Number: ${props.fdu_match_methods?.['exact_by_words_standard']}`}</div>
          <div>{`Exact Words Strong: ${props.fdu_match_methods?.['exact_by_words_strong']}`}</div>
          <div>{`Exact Words: ${props.fdu_match_methods?.['exact_by_words']}`}</div>
          <div>{`Section Match: ${props.fdu_match_methods?.['section match']}`}</div>
          <div>{`Nbayes: ${props.fdu_match_methods?.['nbayes']}`}</div>
          <div>{`Context w/ Account Type: ${props.fdu_match_methods?.['context account type']}`}</div>
          <div>{`Context w/ Standard Account Number: ${props.fdu_match_methods?.['context standard account number']}`}</div>
          <div>{`Context w/ Non Standard Account Number:${props.fdu_match_methods?.['context nonstandard account number']}`}</div>
          <div>{`Historic Nbayes: ${props.fdu_match_methods?.['historic nbayes']}`}</div>
          <div>{`Historic Context w/ Account Type: ${props.fdu_match_methods?.['historic context account type']}`}</div>
          <div>{`Historic Context w/ Standard Account Number: ${props.fdu_match_methods?.['historic context standard account number']}`}</div>
          <div>{`Historic Context w/ Non Standard Account Number:${props.fdu_match_methods?.['historic context nonstandard account number']}`}</div>
        </div>
      )
    } else if (props.user_type === 'Admin' && props.fdu_confidence_percent && !displayFileInfo) {
      return (
        <div>
          <button onClick={() => setDisplayFileInfo(true)}>{`Confidence: ${props.fdu_confidence_percent.toFixed(2)}% - Show Match Details`}</button>
        </div>
      )
    }
  }

  const bodyMinWidth = props.user_type === 'Admin' ? 1334 + (119 * (props.years.length)) : 1246 + (119 * (props.years.length))
  const maxWidth = { 'maxWidth': bodyMinWidth }

  return (
    <div className='row'>
      <div className='col-md-12'>
        {reportsProgressBar ?
          <ProgressBarModal
            job={'CompanyCalculationWorker'}
            jobID={jobID}
            noActionCable={true}
            refresh={true}
            path={'/reports'}
          /> : null}
        {practiceCalcsProgressBar ?
          <ProgressBarModal
            job={'PracticeCalculationWorker'}
            refresh={true}
            path={'/reports'}
          /> : null}
        <div id="sticky-side-btns">
          <TourBtn />
        </div>
        <div className='mapper-sticky' style={maxWidth}>
          <div className='mapper-header'>
            <div className='company-header'>
              <h3 className='company-title'>Company: {props.company_name}</h3>
              <div className='mapper-company-info'>
                <h4 className='company-industry'>Industry: {props.naics_code}, {props.industry}</h4>
                <h4 className='company-industry'>Fiscal Year End: {props.fiscal_year_end}</h4>
              </div>
              <div className='rows-and-review'>
                <h5 className='row-count '>Total Row Count: {props.row_count}</h5>
                <button className='submit-mapping-button btn btn-primary' type='button' disabled={whoReviewed && whoReviewed.length > 0} onClick={(e) => handleReview(e)}>{whoReviewed && whoReviewed.length > 0 ? 'Reviewed' : 'Click To Mark Reviewed'}</button>
              </div>
            </div>
            <FduSelect list={props.fdu_list} path='/mapping_approvals/new?id=:id' />
          </div>
          {renderFileInfo()}
          {props.user_type === 'Admin' && props.fiscal_year_end !== '12/31'
            ? <div className='fiscal-year-warning-text'>
              <p style={{ 'textTransform': 'uppercase', 'fontWeight': 'bold' }}>This client has a different Fiscal Year End than 12/31!!!</p>
              <p>You do not need to worry about mapping the years to the previous year. They will be compared automatically with Peer data which is Calendar Year End (12/31).</p>
              <p>Ex: If the file has the years 2019, 2020, and 2021, then 2019 is compared to &#8594; 2018, 2020 &#8594; 2019, and 2021 &#8594; 2020.</p>
              <p>If you change the Fiscal Year End <b>after</b> uploading some files you will need to reupload those files so that the years will match up correctly.</p>
            </div>
            : null
          }
          <div>
            <div className='mapper-actions pull-right'>
              {props.user_type === 'Admin' && <a id='recalculate-btn' className='' onClick={remap} href='#'>Remap</a>}
              <a id='recalculate-btn' className='' onClick={recalculate} href='#'>Recalculate</a>
              <div className='historic-button btn btn-primary ' id='hist-button' onClick={() => handleRowDisplay('historic')} >
                {hideHistorics ? 'SHOW HISTORIC MATCHES' : 'HIDE HISTORIC MATCHES'}
              </div>
              <form id='mapping-form' action='/practice_calculations' acceptCharset='UTF-8' data-remote='true' method='post' >
                <input type='hidden' name='authenticity_token' value={window.token} />
                <input name='utf8' type='hidden' value='✓' />
                <input
                  type='submit'
                  value='Update Practice Calculations'
                  className='submit-mapping-button btn btn-primary success '
                  onClick={() => {
                    document.querySelector('.mapper-sticky').style.zIndex = 0;
                    setPracticeCalcsProgressBar(true);
                  }}
                />
              </form>
              <button className='submit-mapping-button btn btn-primary ' type='submit' onClick={(e) => handleGenerateReports(e)}>Generate Reports</button>
              <i className={` mapper-balance-sheet-check fa fa-check ${balanced ? 'balanced' : null}`} />
            </div>
            <ul id='mapper-nav-tabs' className='nav nav-tabs' role='tablist' >
              <li className={tab === 'mapper' ? 'active' : ''} role='presentation' onClick={() => setTab('mapper')}>
                <a aria-controls='home' role='tab'>
                  Mapping
                </a>
              </li>
              <li className={tab === 'balance-sheet' ? 'active' : ''} role='presentation' onClick={() => setTab('balance-sheet')}>
                <a aria-controls='balance-sheet' role='tab'>
                  Balance Sheet
                </a>
              </li>
              <li className={tab === 'pnl' ? 'active' : ''} role='presentation' onClick={() => setTab('pnl')}>
                <a aria-controls='pnl' role='tab'>
                  P & L
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className='tab-content' style={maxWidth}>
          {tab === 'mapper'
            ? (<div className={`active`} id='mapping'>
              <MappingTable
                ref={tableRef}
                lastViewedRow={lastViewedRow}
                setLastViewedRow={setLastViewedRow}
                rowHeights={rowHeights}
                rowTops={rowTops}
                isFetching={isFetching}
                fdrs={viewableFdrs}
                tableSortYears={tableSortYears}
                tableSort={tableSort}
                handleRowSort={handleRowSort}
                handleNewNbayesValue={handleNewNbayesValue}
                hideHistorics={hideHistorics}
                user_type={props.user_type}
                naics_code={props.naics_code}
                fdu_id={props.fdu_id}
                fiscalYearEnd={props.fiscal_year_end}
                years={props.years}
                map_list={props.map_list}
                assets_list={props.assets_list}
                liabilities_list={props.liabilities_list}
                equity_list={props.equity_list}
                revenues_list={props.revenues_list}
                expenses_list={props.expenses_list}
                update={update}
                updateRows={updateRows}
                totals={props.totals}
                values={values}
                dragListener={mappingDragger.dragListener}
              />
            </div>)
            : null
          }
          {tab === 'balance-sheet'
            ? (<div className='' id='balance-sheet'>
              <h1>Balance Sheet</h1>
              <MappingSheets
                user_type={props.user_type}
                naics_code={props.naics_code}
                sheet='balance_sheet'
                values={values}
                years={props.years}
                tree={props.tree}
                map_list={props.map_list}
                updateRows={updateRows}
                getRelatedAccounts={getRelatedAccounts}
                accountsExpanded={accountsExpanded}
                rowsInExpand={rowsInExpand}
              />
            </div>)
            : null
          }
          {tab === 'pnl'
            ? (<div className='' id='pnl'>
              <h1>Profit & Loss Statement</h1>
              <MappingSheets
                user_type={props.user_type}
                naics_code={props.naics_code}
                sheet='pnl'
                values={values}
                years={props.years}
                tree={props.tree}
                map_list={props.map_list}
                updateRows={updateRows}
                getRelatedAccounts={getRelatedAccounts}
                accountsExpanded={accountsExpanded}
                rowsInExpand={rowsInExpand}
              />
            </div>)
            : null}
        </div>
      </div>
    </div>
  )
}

export default Mapper;
